import { Component, Input } from '@angular/core';
import { MandatesList, MandatesListColumnDef } from './mandates-list.model';
import { ResultSummaryDto } from '@shared/clients/api.generated';

@Component({
  selector: 'valg-dk-mandates-list',
  templateUrl: './mandates-list.component.html'
})
export class MandatesListComponent {
  @Input() data: MandatesList[] = [];
  @Input() resultSummary?: ResultSummaryDto; 
  @Input() basedOnMissingResults = false;

  mandatesListColumnDef = MandatesListColumnDef;
}
